// extracted by mini-css-extract-plugin
export default {"pointer":"Copyable_pointer__KTphB"};